import { BaseGroupType } from "src/app/reusables/models/group-type.model";
import { TypeFormats } from "src/shared/types/exportItem";

export interface BudgetObject {
    BudgetID: number;
    CompanyID: number;
    GroupLevel: number;
    GroupLevelName: string;
    EmpGroupID: number;
    Amount: number;
    PeriodStartDate: Date;
    CoinsAwarded: number;
    AwardedPercentage: number;
    NotifyLogins: LoginApiModelForBudget[];
    isActive?: boolean;
    isEmpty?: boolean;
    isSaving?: boolean;
    AssignToolVisible?: boolean;
}

export type BudgetResponseData = BudgetObject[] | null | SpendingHistoryForBudgeting | BudgetNotificationResponse;

export interface SpendingHistoryForBudgeting {
    [key: string]: GamificationCoinChange;
}

export interface GamificationCoinChange {
    CoinsAwarded: number;
    CoinsSpent: number;
}

export interface BudgetHistoryParams {
    budgetSettings: BudgetSettings;
    GroupID: number;
    GroupLevel: number;
}

export interface BudgetSettings {
    DateRange: 'Month' | 'Year';
    Month: number;
    Year: number;
}

export interface BudgetNotification {
    LoginID: number;
}

export interface BudgetNotificationResponse {
    BudgetNotificationID: number;
    CompanyID: number;
    LoginID: number;
    BudgetID: number;
    AlertAt: number;
    NotificationSentAt?: number;
    NotificationSentDate?: Date;
    Active: boolean;
    LoginObject: LoginApiModelForBudget;
}

export interface LoginApiModelForBudget {
    LoginID: number;
    CompanyID: number;
    LoginName: string;
    GroupID: number;
    RelatedGroupLevel: number;
    RelatedGroupType: number;
    ProfileID: number;
    ImageID: number;
    Active: boolean;
}

type ColumnContent = {
    [key: string]: string | number | boolean | any;
}

export type Body = {
    format: TypeFormats,
    [key: string]: string | string[] | number | ColumnContent | ColumnContent[] | Record<string, string>[] | boolean | string;
};

export interface Budget {
    budgetList: BudgetRecord[];
    total?: string;
    initBudgetList: BudgetRecord[];
    empGroupLabels?: GroupTypeObj[];
    recGroupLabels?: GroupTypeObj[];
    isLoadingBudgetMeter?: boolean;
    isSavingBudget?: boolean;
    isLoadingGroups?: boolean;
    totalCoinsAwarded?: number;
    totalAmount?: number;
    AlertAt?: number;
    areNotificationsActive?: boolean;
    selectedNotificationBudget?: BudgetObject | null;
}
export interface GroupTypeObj {
    Assignable: boolean;
    BaseGroupType: BaseGroupType;
    CompanyID: number;
    GroupLevel: number;
    GroupTypeName: string;
}
export interface GroupType {
    EmpGroupTypes: GroupTypeObj[];
    RecGroupTypes: GroupTypeObj[];
}

export type GroupTypeRecord = GroupTypeObj & {
    LocalizedName: string;
    initialGroupLevel?: number;
};

export type BudgetRecord = BudgetObject & {
    AmountString: string;
};

export interface GroupDTO {
    GroupID: number;
    CompanyID: number;
    GroupName: string;
    Active: boolean;
    ParentGroupID: number;
    Group1ID: number;
    Group2ID: number;
    Group3ID: number;
    Group4ID: number;
    Group5ID: number;
    BaseGroupType: number;
    Email: string;
    ReceiveAlerts: boolean;
    FirstName: string;
    LastName: string;
    ACDID: number;
    ACDSource: string;
    ImageID: number;
    GroupLevel: number;
}

export interface EmpGroup {
    groupDTO: GroupDTO;
    parentPath: string[];
}

export interface BudgetSetupState {
    editMode: boolean;
    lastIndex: number;
    selectedGroup: GroupTypeRecord;
}

export enum DateRange {
    MONTH = 'Month',
    YEAR = 'Year'
}

export interface BudgetHistoryGroup {
    GroupLevel: number;
    GroupLevelName: string;
    BudgetID: number;
    EmpGroupID: number;
}

export interface BudgetHistoryChartData {
    labels: string[];
    awarded: number[];
    spent: number[];
    dateRange: string;
}

export interface FilterMonth {
    id: number;
    value: string;
    localizedName: string;
    shortMonthName: string;
}

export interface FilterYear {
    id: number;
    value: number;
}

export interface BudgetNotificationAlert {
    name: string;
    selected: boolean;
    value: number;
}